import { defineAsyncComponent } from 'vue';

export default function useCustomComponent() {
  const customComponent = (file) => {
    try {
      require(`@kanrisha/components/Elements/${file}`);

      return defineAsyncComponent(() => import(`@kanrisha/components/Elements/${file}`));
    } catch (e) {
      //
    }
  };

  return {
    customComponent,
  };
}
